module.exports = __webpack_public_path__ + "static/media/irisk-logo-big.c27e3721.png";